import { z } from 'zod';

// Canonical normalized odds observation.
// Emitted to Redis Stream 'odds.tick' by connectors.
// Consumed by: Decision Engine, Storage Writers, Backtest Engine.
export const OddsTickSchema = z.object({
  // "api_tennis:12345678" or "oddspapi:id1234..." — source-prefixed match ID
  sourceMatchId: z.string().min(1),
  // Null until the reconciler identifies the canonical match
  canonicalMatchId: z.string().uuid().nullable(),
  // Always UTC ISO8601 with Z suffix — offset: true needed by Zod, refine enforces Z
  observedAt: z
    .string()
    .datetime({ offset: true })
    .refine((s) => s.endsWith('Z'), {
      message: 'observedAt must be UTC (Z suffix)',
    }),
  source: z.enum(['api_tennis', 'oddspapi']),
  // Sprint 1: h2h only. handicap/totals added in Sprint 2.
  market: z.enum(['h2h', 'handicap', 'totals']),
  // Normalized book slug: 'pinnacle', 'sbobet', 'betano', 'bet365', etc.
  book: z.string().min(1),
  // Decimal odds — both required for H2H markets
  oddsP1: z.number().positive(),
  oddsP2: z.number().positive(),
  isLive: z.boolean(),
  playerA: z.string().min(1),
  playerB: z.string().min(1),
  tournament: z.string().min(1),
  // Match scheduled start — always UTC ISO8601 with Z suffix
  startsAt: z
    .string()
    .datetime({ offset: true })
    .refine((s) => s.endsWith('Z'), {
      message: 'startsAt must be UTC (Z suffix)',
    }),
});

export type OddsTick = z.infer<typeof OddsTickSchema>;
